<template>
  <div class=" container my-5">
    <div class="row ">
      <div v-if="socialBadges.length > 0" class="col-md-8 col-12">
        <ul class="list-inline social-media">
          <li class="list-inline-item">
            <span> Keep in Touch </span>
          </li>
          <li
            v-for="(aSocialBadge, i) in socialBadges"
            class="list-inline-item"
            :key="`social_${i}`"
          >
            <img
              v-if="aSocialBadge"
              @click="handleSocialClick(aSocialBadge.type, aSocialBadge.url)"
              class="display-img"
              :src="aSocialBadge.svg"
              alt=""
            />
          </li>
        </ul>
      </div>
      <div v-if="this.user && false" class="col-md-4 text-end col-12">
        <ul class="list-inline">
          <li class="list-inline-item">
            <span>Add to Shelf</span>
          </li>
          <li class="list-inline-item">
            <b-button
              class="btn btn-follow"
              :class="hasBeenCollected ? 'followed' : ''"
              @click="handleToggleCollectPublishing"
            >
              <span v-if="!hasBeenCollected">Collect</span>
              <span v-else>Collected</span>
            </b-button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import RecordViews from "@/mixins/RecordViews";
import socialsMixin from "@/mixins/Socials";

export default {
  name: "SocialLinks",
  mixins: [RecordViews, socialsMixin],
  components: {},
  props: {
    publishing: {
      type: Object,
      required: false,
      default: () => {}
    },
    user: {
      type: Object,
      required: false,
      default: () => {}
    },
    collectedCorners: {
      type: Array,
      required: false,
      default: () => []
    },
    cornerTitle: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      // socialMap: this.$socials
    };
  },
  computed: {
    hasBeenCollected() {
      return this.collectedCorners.filter(a => {
        return a.id === this.cornerPublishingId;
      })[0];
    },
    cornerPublishingId() {
      return this.publishing
        ? this.publishing.doc
          ? this.publishing.doc.id
          : null
        : null;
    },
    socialBadges() {
      const socialBadges = [];
      if (
        this.publishing &&
        this.publishing.doc &&
        this.publishing.doc.socials &&
        Array.isArray(this.publishing.doc.socials)
      ) {
        this.publishing.doc.socials.forEach(aSocial => {
          //console.log(aSocial.type);

          const socialType = this.$socials.filter(sm => {
            return sm.type == aSocial.type;
          })[0];

          //socialType.svg,

          const aSocialBadge = {
            url: this.makeLink(socialType.prefix, aSocial),
            svg: socialType.svg,
            type: aSocial.type
          };
          socialBadges.push(aSocialBadge);
        });
      }
      return socialBadges;
    },
    socials() {
      return this.corner
        ? this.corner.doc
          ? this.corner.doc.socials
          : null
        : null;
    }
  },
  methods: {
    handleSocialClick(type, url) {
      //recordview
      this.recordView(this.publishing.id, { action: "click", type: type });
      window.open(url, "_blank");
    },
    makeLink(prefix, social) {
      let fullLink = prefix
        .replace(/{profileName}/g, social.profileName)
        .replace(/{profileId}/g, social.userId);
      return fullLink;
    },
    recordView(publishingId, meta) {
      this.$store.dispatch("listings/recordFeedback", {
        userId: this.user ? this.user.uid : null,
        pathId: "publishings",
        entityId: publishingId,
        feedbackType: "social",
        sessionId: this.checkSession("sessions"),
        meta: meta
      });
    },
    openShare() {
      this.showSearch = !this.showSearch;
    },
    handleToggleCollectPublishing(event) {
      const data = {
        collect: !this.hasBeenCollected
      };
      this.$emit("handleToggleCollectPublishing", data);
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.btn-follow {
  border: 1px solid #474d52;
  box-sizing: border-box;
  border-radius: 4px;
  width: 70px;
  height: 28px;
  padding: 0px;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #474d52;
  background-color: #fff;
  transition: 0.2s ease;
  margin-bottom: 24px;
  &:focus {
    box-shadow: none !important;
  }
  &:hover {
    background-color: #474d52;
    color: #fff;
    &:after,
    &:before {
      content: none;
    }
  }
}

.social-media {
  p {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #000000;
  }
  .social {
    display: flex;
    column-gap: 16px;
  }
  img {
    cursor: pointer;
    height: 25px;
    width: 25px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    &:hover {
      background: #dfe3e5;
      box-shadow: 0px 4px 32px rgba(255, 255, 255, 0.3);
    }
  }
}
@media (max-width: 767px) {
  .social-media {
  }
}
</style>
